import { UserAuthority } from '@/constants';
import sponsorLeaderboardService from '@/services/sponsorLeaderboardService';
import { useModel, useRequest } from '@umijs/max';

export default (): {
  sponsorLeaderboards: API.Service.SponsorLeaderboard[];
  sponsorLeaderboardsLoading: boolean;
  refreshSponsorLeaderboards: () => void;
} => {
  const { ready } = useModel('@@initialState', (model) => ({
    ready:
      !!model.initialState?.currentUser &&
      model.initialState?.currentUser?.authority ===
        UserAuthority.ADMINISTRATOR,
    //currentUser: model.initialState?.currentUser,
  }));
  const {
    data: sponsorLeaderboards,
    loading: sponsorLeaderboardsLoading,
    refresh: refreshSponsorLeaderboards,
  } = useRequest(sponsorLeaderboardService.getAllSponsorLeaderboards, {
    ready,
  });

  return {
    sponsorLeaderboards: sponsorLeaderboards || [],
    sponsorLeaderboardsLoading,
    refreshSponsorLeaderboards,
  };
};
